import { RSAA } from 'redux-api-middleware';

export const ACKNOWLEDGEMENTS_IS_FETCHING = 'ACKNOWLEDGEMENTS_IS_FETCHING';
export const ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_SUCCESS =
  'ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_SUCCESS';
export const ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_ERROR =
  'ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_ERROR';

// Initial State
export const initialState = {
  isFetching: false,
  error: null,
  termsAndConditionsAckSent: false
};

export const postTermsAndConditionsAck = () => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_TERMS_AND_CONDITIONS_ACK',
      controlAction: 'bci:add',
      types: [
        ACKNOWLEDGEMENTS_IS_FETCHING,
        ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_SUCCESS,
        ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_ERROR
      ]
    }
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case ACKNOWLEDGEMENTS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_SUCCESS:
      return {
        ...state,
        termsAndConditionsAckSent: true,
        isFetching: false,
        error: null
      };
    case ACKNOWLEDGEMENTS_TERMS_AND_CONDITIONS_ACK_SENT_ERROR:
      return {
        ...state,
        termsAndConditionsAckSent: true,
        isFetching: false,
        error: true
      };
    default:
      return state;
  }
};
